import { useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useEffect, useState } from "react";
import { DictionaryType } from "../../types";
import SelectOption from "./SelectOption";
import { useDebounce } from "../../hooks/useDebounce";
import { optionsType } from "./MultiSelect";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import Select from "react-select";

type Props = {
  field: any;
  setValue?: any;
  labelKey?: any;
  index?: number;
  isGroupList?: boolean;
  groupOptions?: {
    OrginizeBy: string;
    listGroupKey: string;
    groupTitleKey: string;
  };
  AfterLoading?:(data:any)=>void;
  fetchFunction: any;
  isDisabled?: boolean;
  pathParams?: any;
  valueKey?: string;
  maxMenuHight?:string
  dependsOn?: any[];
  turnOff?: boolean;
  excludedValues?: any;
  changeCallBack?: (selected: any) => void;
  noOptionsMessage?: string;
  value?: any;
  isPlayersSelect?: boolean;
  isMulti?: boolean;
  handleOption?: any;
  addOption?:any
  dependOn?: any[];
  position?: "top" | "bottom";
  isCustomOption?:boolean;
  customOptionComponent?:any
};

function MultiSearchableSelect({
  field,
  isDisabled,
  turnOff = false,
  fetchFunction,
  groupOptions,
  isCustomOption=false,
  customOptionComponent=Option,
  dependsOn,
  isGroupList = false,
  position = "bottom",
  pathParams,
  addOption,
  handleOption = null,
  maxMenuHight = "200px",
  labelKey = "name",
  valueKey = "id",
  changeCallBack,
  AfterLoading,
  excludedValues,
  noOptionsMessage,
  dependOn = [],
  isPlayersSelect = false,
  isMulti = true, // now default is multi-select
}: Props) {
  const selectedClub = useSelector(
    (state: UserSliceType) => state.user.selectedClub
  );
  const { placeHolders }: DictionaryType = useGetDictionary();
  const [query, setQuery] = useState<string>("");
  const [options, setOptions] = useState<optionsType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  console.log(pathParams);

  const { data, isSuccess, isError } = fetchFunction(
    { name: useDebounce(query), club_id: selectedClub, ...pathParams },
    { skip: !loading }
  );
  useEffect(() => {
    //   setOptions(selectedServices)
    if (!turnOff) {
      setLoading(true);
      !isGroupList &&
        setOptions((prev) => prev.filter((item: any) => item.id !== 0));
    }
  }, [selectedClub, dependsOn, turnOff, ...dependOn]);
  // useEffect(() => {
  //   setLoading(true);
  // }, [selectedClub, dependsOn]);

  useEffect(() => {
    if (isSuccess && data) {
      const dataKey = Object.keys(data)[0];

      let fetchedValues = data[dataKey].map((item: optionsType) => item);
      if (isGroupList && fetchedValues) {
        if (groupOptions?.OrginizeBy) {
          const groupList: any = [];

          let groupCounter = 0;
          for (let item of fetchedValues) {
            groupCounter = 0;
            item[groupOptions?.listGroupKey].forEach((listItem: any) => {
              groupList.push({
                ...listItem,
                groupIndex: groupCounter,
                groupKey: item[groupOptions?.OrginizeBy],
                groupTitle: item[groupOptions?.groupTitleKey],
              });
              groupCounter++;
            });
          }
          console.log(groupList);

          fetchedValues = groupList;
        }
      }
      setOptions((prev) => {
        const newValues = [...prev];
        if(addOption){
          newValues.push(addOption)
        }
        fetchedValues.forEach((item: any) => {
          if (
            !newValues.find((existing) => existing[valueKey] === item[valueKey])
          ) {
            newValues.push(item);
          }
        });

        return newValues;
      });
      setLoading(false);
    }
  }, [isSuccess, data]);
  useEffect(()=>{
      if(data && isSuccess && options){
        AfterLoading && AfterLoading(options)
      }
  },[data,isSuccess,options])
  if (isError) {
    setLoading(false);
  }

  return (
    <Select
      menuPlacement={position || "auto"}
      components={
        isMulti
          ? isCustomOption? 
          {
              IndicatorSeparator: () => null,
              Option: customOptionComponent,
              // Option: PlayerOption,
              // MenuList: CustomMenuList,
            }: {
              IndicatorSeparator: () => null,
              Option: (props) => SelectOption({ ...props, isGroupList }),
              // Option: PlayerOption,
              // MenuList: CustomMenuList,
            }
          : {
              IndicatorSeparator: () => null,
            }
      }
      styles={{
        ...selectStyle,
        menuList: (provided) => ({
          ...provided,
          padding: "0",

          maxHeight: maxMenuHight,
          overflowY: "auto", // Enables scrolling

          scrollbarWidth: "inherit", // For Firefox
          "&::-webkit-scrollbar": {
            width: "9px",
            height: "15px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#1E1850", // Scrollbar color
            borderRadius: "10px", // Scrollbar shape
            border: "2px",
            borderStyle: "solid",
            borderColor: "#d8d7d7",
            position: "absolute",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            //backgroundColor: "#555", // Hover color
          },
          "&::-webkit-scrollbar-track": {
            background: "#f3f3f3",
            borderRadius: "10px", // Track color
          },

          "&::-webkit-scrollbar-button": {
            display: "none",
          },
        }),
      }}
      classNamePrefix="react-select w-full"
      theme={selectTheme}
      {...field}
      isDisabled={isDisabled}
      isMulti={isMulti}
      options={
        excludedValues
          ? handleOption
            ? handleOption(
                options.filter(
                  (option: any) => !excludedValues.includes(option.id)
                )
              )
            : options.filter(
                (option: any) => !excludedValues.includes(option.id)
              )
          : handleOption
          ? handleOption(options,setOptions)
          : options
      }
      className="w-full"
      getOptionLabel={(option: any) => option[labelKey]}
      getOptionValue={(option: any) => option[valueKey]}
      onChange={(selectedOptions: any) => {
        if (changeCallBack) changeCallBack(selectedOptions);

        const mappedValue = isMulti
          ? selectedOptions?.map((s: any) => s[valueKey])
          : selectedOptions?.[valueKey] || null;

        field.onChange(mappedValue);
      }}
      onInputChange={(inputValue, { action }) => {
        if (action === "input-change") {
          setLoading(true);
          setQuery(inputValue);
        }
      }}
      isLoading={loading}
      value={
        isMulti
          ? options.filter((option) => field.value?.includes(option[valueKey]))
          :handleOption? handleOption(options).find(
              (option:any) =>
                option[valueKey] === field.value || option.name === field.value
            ) || null:options.find(
              (option:any) =>
                option[valueKey] === field.value || option.name === field.value
            ) || null
      }
      hideSelectedOptions={false}
      isSearchable={true}
      noOptionsMessage={() =>
        noOptionsMessage ? noOptionsMessage : "No Options"
      }
      placeholder={placeHolders.select}
    />
  );
}

export default MultiSearchableSelect;
